import pipe from '@s-ui/js/lib/pipe'
import {fromCamelToSnakeCase, toQueryString} from '@s-ui/js/lib/string'

import PageMappersFactory from '../../page/Mappers/factory.js'
import TrackingValueObjectsFactory from '../ValueObjects/factory.js'
import {FromDraftJsonToDraftTrackingJsonMapper} from './FromDraftJsonToDraftTrackingJsonMapper.js'
import {FromEventTrackingDataToEventTrackingDataValueObjectMapper} from './FromEventTrackingDataToEventTrackingDataValueObjectMapper.js'
import FromPageTrackingJsonToAdvertisementsValueObjectMapper from './FromPageTrackingJsonToAdvertisementsValueObjectMapper.js'
import FromPageTrackingJsonToTrackingDataValueObjectMapper from './FromPageTrackingJsonToTrackingDataValueObjectMapper.js'
import {FromSearchJSONToFiltersTrackingMapper} from './FromSearchJSONToFiltersTrackingMapper.js'
import IdentifyMapper from './IdentifyMapper.js'
import TrackingAdsDetailMapper from './TrackingAdsDetailMapper.js'
import TrackingAdsListMapper from './TrackingAdsListMapper.js'
import TrackingAppraisalVehicleMapper from './TrackingAppraisalVehicleMapper.js'
import {TrackingAuthenticationMapper} from './TrackingAuthenticationMapper.js'
import TrackingCheckoutSuccessMapper from './trackingCheckoutSuccessMapper.js'
import TrackingComparatorMapper from './TrackingComparatorMapper.js'
import TrackingDataObjectMapper from './TrackingDataObjectMapper.js'
import {TrackingDealersListMapper} from './TrackingDealersListMapper.js'
import TrackingErrorMapper from './TrackingErrorMapper.js'
import {TrackingEventAdComplaintMapper} from './TrackingEventAdComplaintMapper.js'
import {TrackingEventAdSubscriptionPriceOptionClickedMapper} from './TrackingEventAdSubscriptionPriceOptionClickedMapper.js'
import {TrackingEventFavoriteAdShareMapper} from './TrackingEventFavoriteAdShareMapper.js'
import {TrackingEventLandingInstantOfferMapper} from './TrackingEventLandingInstantOfferMapper.js'
import {TrackingEventsInstantOfferMapper} from './TrackingEventsInstantOfferMapper.js'
import {TrackingEventsVisibilityProductsMapper} from './TrackingEventsVisibilityProductsMapper.js'
import {TrackingEventUserProfileEditMapper} from './TrackingEventUserProfileEditMapper.js'
import {TrackingInstantOfferPageMapper} from './TrackingInstantOfferPageMapper.js'
// web_seller_instant_offer_landing_test
import {TrackingLandingInstantOfferTestMapper} from './TrackingLandingInstantOfferTestMapper.js'
import {TrackingLeadMapper} from './TrackingLeadMapper.js'
import TrackingModelDetailMapper from './TrackingModelDetailMapper.js'
import TrackingNewsDetailMapper from './TrackingNewsDetailMapper.js'
import TrackingNewsGallerySearchMapper from './TrackingNewsGallerySearchMapper.js'
import TrackingNewsMapper from './TrackingNewsMapper.js'
import TrackingPageVehicleConfiguratorMapper from './TrackingPageVehicleConfiguratorMapper.js'
import TrackingPageVehicleSuggesterMapper from './TrackingPageVehicleSuggesterMapper.js'
import TrackingProfessionalStockMapper from './TrackingProfessionalStockMapper.js'
import TrackingProxyMapper from './TrackingProxyMapper.js'
import {TrackingPublishMyAdMapper} from './TrackingPublishMyAdMapper.js'
import {TrackingPublishYourCarWithPlateMapper} from './TrackingPublishYourCarWithPlateMapper.js'
import {TrackingPublishYourCarWithPlateResultsMapper} from './TrackingPublishYourCarWithPlateResultsMapper.js'
import {TrackingRecommendationsMapper} from './TrackingRecommendationsMapper.js'
import TrackingTechnicalDetailsMapper from './TrackingTechnicalDetailsMapper.js'
import TrackingUserFavoritesDealersMapper from './TrackingUserFavoritesDealersMapper.js'
import TrackingUserFavoritesMapper from './TrackingUserFavoritesMapper.js'
import {TrackingUserProfileEditMapper} from './TrackingUserProfileEditMapper.js'
import TrackingWdylMapper from './TrackingWdylMapper.js'

export default class TrackingMappersFactory {
  static trackingProxyMapper = ({config}) =>
    new TrackingProxyMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        }),
      trackingAdsListMapper: TrackingMappersFactory.trackingAdsListMapper({
        config
      }),
      trackingAdsDetailMapper: TrackingMappersFactory.trackingAdsDetailMapper({
        config
      }),
      trackingAuthenticationMapper: TrackingMappersFactory.trackingAuthenticationMapper({
        config
      }),
      trackingInstantOfferPageMapper: TrackingMappersFactory.trackingInstantOfferPageMapper({
        config
      }),
      trackingPageVehicleConfiguratorMapper: TrackingMappersFactory.trackingPageVehicleConfiguratorMapper({
        config
      }),
      trackingPageVehicleSuggesterMapper: TrackingMappersFactory.trackingPageVehicleSuggesterMapper({
        config
      }),
      trackingProfessionalStockMapper: TrackingMappersFactory.trackingProfessionalStockMapper({
        config
      }),
      trackingPublishMyAdMapper: TrackingMappersFactory.trackingPublishMyAdMapper({config}),
      trackingPublishYourCarWithPlateMapper: TrackingMappersFactory.trackingPublishYourCarWithPlateMapper({config}),
      trackingPublishYourCarWithPlateResultsMapper: TrackingMappersFactory.trackingPublishYourCarWithPlateResultsMapper(
        {
          config
        }
      ),
      // web_seller_instant_offer_landing_test
      trackingLandingInstantOfferTestMapper: TrackingMappersFactory.trackingLandingInstantOfferTestMapper({
        config,
        fromPageTrackingJsonToTrackingDataValueObjectMapper:
          TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
            config
          })
      }),
      trackingNewsMapper: TrackingMappersFactory.trackingNewsMapper({
        config
      }),
      trackingNewsDetailMapper: TrackingMappersFactory.trackingNewsDetailMapper({config}),
      trackingNewsGallerySearchMapper: TrackingMappersFactory.trackingNewsGallerySearchMapper({
        config
      }),
      trackingModelDetailMapper: TrackingMappersFactory.trackingModelDetailMapper({
        config
      }),
      trackingWdylMapper: TrackingMappersFactory.trackingWdylMapper({config}),
      trackingTechnicalDetailsMapper: TrackingMappersFactory.trackingTechnicalDetailsMapper({config}),
      trackingAppraisalVehicleMapper: TrackingMappersFactory.trackingAppraisalVehicleMapper({
        config
      }),
      trackingCheckoutSuccessMapper: TrackingMappersFactory.trackingCheckoutSuccessMapper({
        config
      }),
      trackingErrorMapper: TrackingMappersFactory.trackingErrorMapper({
        config
      }),
      trackingDealersListMapper: TrackingMappersFactory.trackingDealersListMapper({config}),
      trackingComparatorMapper: TrackingMappersFactory.trackingComparatorMapper({config}),
      trackingUserFavoritesMapper: TrackingMappersFactory.trackingUserFavoritesMapper({config}),
      trackingUserFavoritesDealersMapper: TrackingMappersFactory.trackingUserFavoritesDealersMapper({config}),
      trackingUserProfileEditMapper: TrackingMappersFactory.trackingUserProfileEditMapper({config}),
      trackingRecommendationsMapper: TrackingMappersFactory.trackingRecommendationsMapper({config}),
      valueObject: TrackingValueObjectsFactory.trackingDataValueObject
    })

  static trackingAdsListMapper = ({config}) =>
    new TrackingAdsListMapper({
      config,
      fromPageTrackingJsonToAdvertisementsValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToAdvertisementsValueObjectMapper({config}),
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        }),
      fromSearchJSONToFiltersTrackingMapper: TrackingMappersFactory.fromSearchJSONToFiltersTrackingMapper({config}),
      fromQueryParamsToPageNameValueObjectPageMapper:
        PageMappersFactory.fromQueryParamsToTargetPageValueObjectPageMapper({
          config
        })
    })

  static trackingAdsDetailMapper = ({config}) =>
    new TrackingAdsDetailMapper({
      config,
      fromPageTrackingJsonToAdvertisementsValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToAdvertisementsValueObjectMapper({config}),
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        }),
      trackingDataObjectMapper: TrackingMappersFactory.trackingDataObjectMapper({config})
    })

  static trackingAuthenticationMapper = ({config}) =>
    new TrackingAuthenticationMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingInstantOfferPageMapper = ({config}) =>
    new TrackingInstantOfferPageMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        })
    })

  static trackingProfessionalStockMapper = ({config}) =>
    new TrackingProfessionalStockMapper({
      config,
      fromPageTrackingJsonToAdvertisementsValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToAdvertisementsValueObjectMapper({config}),
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        }),
      fromSearchJSONToFiltersTrackingMapper: TrackingMappersFactory.fromSearchJSONToFiltersTrackingMapper({config})
    })

  static trackingPublishMyAdMapper = ({config}) =>
    new TrackingPublishMyAdMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingPublishYourCarWithPlateMapper = ({config}) =>
    new TrackingPublishYourCarWithPlateMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingPublishYourCarWithPlateResultsMapper = ({config}) =>
    new TrackingPublishYourCarWithPlateResultsMapper({
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingNewsMapper = ({config}) =>
    new TrackingNewsMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        })
    })

  // web_seller_instant_offer_landing_test
  static trackingLandingInstantOfferTestMapper = ({config}) =>
    new TrackingLandingInstantOfferTestMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        })
    })

  static trackingNewsDetailMapper = ({config}) =>
    new TrackingNewsDetailMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        })
    })

  static trackingNewsGallerySearchMapper = ({config}) =>
    new TrackingNewsGallerySearchMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        })
    })

  static trackingModelDetailMapper = ({config}) =>
    new TrackingModelDetailMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingPageVehicleConfiguratorMapper = ({config}) =>
    new TrackingPageVehicleConfiguratorMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingPageVehicleSuggesterMapper = ({config}) =>
    new TrackingPageVehicleSuggesterMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingWdylMapper = ({config}) =>
    new TrackingWdylMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingTechnicalDetailsMapper = ({config}) =>
    new TrackingTechnicalDetailsMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingDealersListMapper = ({config}) =>
    new TrackingDealersListMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config}),
      fromSearchJSONToFiltersTrackingMapper: TrackingMappersFactory.fromSearchJSONToFiltersTrackingMapper({config}),
      fromCamelToSnakeCase,
      toQueryString
    })

  static trackingRecommendationsMapper = ({config}) =>
    new TrackingRecommendationsMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config}),
      fromPageTrackingJsonToAdvertisementsValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToAdvertisementsValueObjectMapper({config})
    })

  static trackingAppraisalVehicleMapper = ({config}) =>
    new TrackingAppraisalVehicleMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingCheckoutSuccessMapper = ({config}) =>
    new TrackingCheckoutSuccessMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingErrorMapper = ({config}) =>
    new TrackingErrorMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        })
    })

  static trackingComparatorMapper = ({config}) =>
    new TrackingComparatorMapper({
      config,
      fromPageTrackingJsonToAdvertisementsValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToAdvertisementsValueObjectMapper({config}),
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({config})
    })

  static trackingUserFavoritesMapper = ({config}) =>
    new TrackingUserFavoritesMapper({
      config,
      fromPageTrackingJsonToAdvertisementsValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToAdvertisementsValueObjectMapper({config}),
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        }),
      fromSearchJSONToFiltersTrackingMapper: TrackingMappersFactory.fromSearchJSONToFiltersTrackingMapper({config})
    })

  static trackingUserFavoritesDealersMapper = ({config}) =>
    new TrackingUserFavoritesDealersMapper({
      config,
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        })
    })

  static trackingUserProfileEditMapper = ({config}) =>
    new TrackingUserProfileEditMapper({
      config,
      fromPageTrackingJsonToAdvertisementsValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToAdvertisementsValueObjectMapper({config}),
      fromPageTrackingJsonToTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToTrackingDataValueObjectMapper({
          config
        })
    })

  static fromDraftJsonToDraftTrackingJsonMapper = ({config}) =>
    new FromDraftJsonToDraftTrackingJsonMapper({
      config,
      trackingDataObjectMapper: TrackingMappersFactory.trackingDataObjectMapper({config})
    })

  static fromPageTrackingJsonToTrackingDataValueObjectMapper = ({config}) =>
    new FromPageTrackingJsonToTrackingDataValueObjectMapper({
      config,
      trackingDataObjectMapper: TrackingMappersFactory.trackingDataObjectMapper({config}),
      toQueryString,
      fromCamelToSnakeCase,
      pipe,
      valueObject: TrackingValueObjectsFactory.trackingDataValueObject
    })

  static fromPageTrackingJsonToAdvertisementsValueObjectMapper = ({config}) =>
    new FromPageTrackingJsonToAdvertisementsValueObjectMapper({
      config,
      valueObject: TrackingValueObjectsFactory.advertisementsValueObject,
      fromPageNameToConstantNamingPageName: PageMappersFactory.fromPageNameToConstantNamingPageName({config})
    })

  static fromSearchJSONToFiltersTrackingMapper = ({config}) => new FromSearchJSONToFiltersTrackingMapper({config})

  static identifyMapper = ({config}) => new IdentifyMapper({config})

  static trackingDataObjectMapper = ({config}) =>
    new TrackingDataObjectMapper({
      config,
      toQueryString,
      fromCamelToSnakeCase
    })

  static trackingEventUserProfileEditMapper = ({config}) => new TrackingEventUserProfileEditMapper({config})

  static trackingEventFavoriteAdShareMapper = ({config}) => new TrackingEventFavoriteAdShareMapper({config})

  static trackingEventAdComplaintMapper = ({config}) => new TrackingEventAdComplaintMapper({config})

  static trackingEventLandingInstantOfferMapper = ({config}) => new TrackingEventLandingInstantOfferMapper({config})
  static trackingEventsInstantOfferMapper = ({config}) => new TrackingEventsInstantOfferMapper({config})
  static trackingEventsVisibilityProductsMapper = ({config}) => new TrackingEventsVisibilityProductsMapper({config})

  static fromEventTrackingDataToEventTrackingDataValueObjectMapper = ({config}) =>
    new FromEventTrackingDataToEventTrackingDataValueObjectMapper({
      config,
      valueObject: TrackingValueObjectsFactory.trackingDataValueObject,
      fromPageTrackingJsonToAdvertisementsValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToAdvertisementsValueObjectMapper({config}),
      trackingEventUserProfileEditMapper: TrackingMappersFactory.trackingEventUserProfileEditMapper({config}),
      trackingEventFavoriteAdShareMapper: TrackingMappersFactory.trackingEventFavoriteAdShareMapper({config}),
      trackingEventsInstantOfferMapper: TrackingMappersFactory.trackingEventsInstantOfferMapper({config}),
      trackingEventsVisibilityProductsMapper: TrackingMappersFactory.trackingEventsVisibilityProductsMapper({config}),
      trackingEventLandingInstantOfferMapper: TrackingMappersFactory.trackingEventLandingInstantOfferMapper({config}),
      trackingEventAdComplaintMapper: TrackingMappersFactory.trackingEventAdComplaintMapper({config}),
      trackingEventAdSubscriptionPriceOptionClickedMapper:
        TrackingMappersFactory.trackingEventAdSubscriptionPriceOptionClickedMapper({config}),
      fromPageNameToConstantNamingPageName: PageMappersFactory.fromPageNameToConstantNamingPageName({config}),
      fromCamelToSnakeCase,
      toQueryString,
      pipe
    })

  static trackingLeadMapper = ({config}) => new TrackingLeadMapper({config})

  static trackingEventAdSubscriptionPriceOptionClickedMapper = ({config}) =>
    new TrackingEventAdSubscriptionPriceOptionClickedMapper({config})
}
